import styled from 'styled-components';

export const StyledAppCarousel = styled.div`
  transition: linear 0.2s;
  display: flex;
  flex-direction: row;
  height: 100%;
  transform: translateX(-${({ $current }) => $current * 100}%);

  .app-carousel-item {
    width: 100%;
    min-width: 100%;
    height: 100%;
    min-height: 100%;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    overflow-y: auto;
    transform: unset;
  }
`;
